// Faixa de CEP por UF (Correios, faixas nacionais). Cada tupla e
// [inicio, fim, UF] com o CEP como numero de 8 digitos (sem hifen).
const FAIXAS: ReadonlyArray<readonly [number, number, string]> = [
  [1000000, 19999999, 'SP'],
  [20000000, 28999999, 'RJ'],
  [29000000, 29999999, 'ES'],
  [30000000, 39999999, 'MG'],
  [40000000, 48999999, 'BA'],
  [49000000, 49999999, 'SE'],
  [50000000, 56999999, 'PE'],
  [57000000, 57999999, 'AL'],
  [58000000, 58999999, 'PB'],
  [59000000, 59999999, 'RN'],
  [60000000, 63999999, 'CE'],
  [64000000, 64999999, 'PI'],
  [65000000, 65999999, 'MA'],
  [66000000, 68899999, 'PA'],
  [68900000, 68999999, 'AP'],
  [69000000, 69299999, 'AM'],
  [69300000, 69399999, 'RR'],
  [69400000, 69899999, 'AM'],
  [69900000, 69999999, 'AC'],
  [70000000, 72799999, 'DF'],
  [72800000, 72999999, 'GO'],
  [73000000, 73699999, 'DF'],
  [73700000, 76799999, 'GO'],
  [76800000, 76999999, 'RO'],
  [77000000, 77999999, 'TO'],
  [78000000, 78899999, 'MT'],
  [78900000, 78999999, 'RO'],
  [79000000, 79999999, 'MS'],
  [80000000, 87999999, 'PR'],
  [88000000, 89999999, 'SC'],
  [90000000, 99999999, 'RS'],
]

// So resolve o basico: cliente com CEP mal digitado devolve null e o motor de
// imposto nao calcula (comportamento de hoje) -- nao lanca, nunca.
export function ufDoCep(cep: string | null | undefined): string | null {
  if (!cep) return null
  const limpo = cep.trim().replace(/\D/g, '')
  if (limpo.length !== 8) return null
  const numero = Number(limpo)
  const faixa = FAIXAS.find(([inicio, fim]) => numero >= inicio && numero <= fim)
  return faixa ? faixa[2] : null
}
